export default __webpack_public_path__ + "static/media/section1-item-3-h5.534ea426.png";